import {
  BrowserRouter as Router,
  Routes,
  Route
} from 'react-router-dom';
import PersonDetailPage from './components/PersonDetailPage'
import MainPage from './components/MainPage';
import PasswordPage from './components/PasswordPage';
import RequireAuth from './components/RequireAuth';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          {/* Public route: password gate at root */}
          <Route path="/" element={<PasswordPage />} />

          {/* Protected routes */}
          <Route element={<RequireAuth />}>
            <Route path="/app" element={<MainPage />} />
            <Route path="/person/:id" element={<PersonDetailPage />} />
          </Route>

          {/* (Optional) catch-all → root */}
          <Route path="*" element={<PasswordPage />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}
